import { useInfiniteQuery } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { type GetEventsDto } from '@/types/dtos/events/response/get-events.dto.ts';
import { useAuth } from '@clerk/clerk-react';

export const GET_EVENTS_QUERY_KEY = 'get-events';
const PAGE_SIZE = 20;

export const useEventsQuery = (organizationId: string, search?: string) => {
  const { getToken } = useAuth();

  return useInfiniteQuery({
    queryKey: [GET_EVENTS_QUERY_KEY, organizationId, search],
    queryFn: async ({ pageParam }) => {
      const token = await getToken();
      return getEvents({ organizationId, pageParam, token: token ?? '', search });
    },
    initialPageParam: '',
    getNextPageParam: (lastPage) => lastPage.pagination.nextCursor,
  });
};

const getEvents = async ({
  organizationId,
  pageParam,
  token,
  search,
}: {
  organizationId: string;
  pageParam: string;
  token: string;
  search?: string;
}): Promise<GetEventsDto> => {
  let url = `${import.meta.env.VITE_API_URL}/events/organization/${organizationId}?limit=${PAGE_SIZE}`;
  if (pageParam !== '') {
    url += `&cursor=${pageParam}`;
  }
  if (search && search.trim() !== '') {
    url += `&search=${encodeURIComponent(search.trim())}`;
  }
  return sendJSONRequest({ url, method: METHOD.GET, token });
};
